import { useState, useEffect, useRef } from 'react'

export const useScrollDirection = () => {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down'>('up')
  const [isAtTop, setIsAtTop] = useState(true)
  const lastScrollY = useRef(0)

  useEffect(() => {
    const updateScrollDirection = () => {
      const isScrollLocked = document.body.style.position === 'fixed'

      if (isScrollLocked) return

      const currentScrollY = window.scrollY
      const prevScrollY = lastScrollY.current

      setIsAtTop(currentScrollY <= 0)

      if (currentScrollY > prevScrollY) {
        setScrollDirection('down')
      } else if (currentScrollY < prevScrollY) {
        setScrollDirection('up')
      }

      lastScrollY.current = currentScrollY
    }

    window.addEventListener('scroll', updateScrollDirection, { passive: true })
    updateScrollDirection()

    return () => window.removeEventListener('scroll', updateScrollDirection)
  }, [])

  return { scrollDirection, isAtTop }
}
